import { ModelTranslator } from '@/types/ApiResponseTypes'
import { InvoiceRequestBody } from '@/types/invoice/InvoiceResponse'
import { InvoiceRequest, isInvoiceRequest } from '@/types/invoice/InvoiceType'

class InvoiceRequestTranslator implements ModelTranslator<InvoiceRequest> {
  convertToModel(model: any): InvoiceRequestBody {
    if (isInvoiceRequest(model)) {
      return model
    }
    return { page: 0, pageSize: -1 }
  }
}
export default new InvoiceRequestTranslator()
